export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13507.e6a868e5.jpg";